import styled from "styled-components";

export const Container = styled.div`
  width: 80vw;
  /* height: 80vh; */
  max-width: 800px;
  font-weight: 500;
  color: #c7cad9;
  h4 {
    font-size: 18px;
    margin: 10px 0 20px 0;
  }
  .search-coin {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    margin: 12px 0;
    font-size: 16px;
    border-radius: 12px;
    outline: none;
    border: 2px solid rgba(105, 108, 128, 0.12);
    background-color: #12131a;
  }
  ul.ul-coin {
    padding: 0;
  }
  .common-coin__title {
    font-size: 12px;
    margin: 12px 0;
  }
  .ul-common-coin {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;
  }
  .li-common-coin {
    display: flex;
    align-items: center;
    padding: 6px 10px;
    margin: 4px 8px 4px 0;
    border-radius: 18px;
    list-style: none;
    transition: all 0.2s;
    background-color: #252833;
    cursor: pointer;
    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
    img {
      width: 24px;
    }
    p {
      color: #c7cad9;
      font-size: 14px;
      margin-left: 6px;
      line-height: 0;
    }
  }

  .ul-coin {
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    height: 50vh;
    overflow: auto;
  }
  .li-coin {
    padding: 8px 20px 8px 10px;
    border-radius: 10px;
    list-style: none;
    display: flex;
    align-items: center;
    transition: all 0.2s;
    cursor: pointer;
    &:hover {
      background-color: rgba(0, 0, 0, 0.2);
    }
    img {
      width: 32px;
      /* margin: 5px; */
    }
    &__symbol {
      color: #c7cad9;
      font-size: 14px;
      margin-left: 8px;
    }
    &__name {
      margin-left: 8px;
      color: #696c80;
      font-size: 12px;
    }
  }
  .searchInputWrapper {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 12px;
    margin: 12px 0;
    font-size: 16px;
    border-radius: 12px;
    outline: none;
    border: 2px solid rgba(105, 108, 128, 0.12);
    background-color: #12131a;
  }
  .searchInputWrapper svg {
    margin-right: 12px;
  }
  .searchInputWrapper input {
    background: 0 0;
    flex: 1 1;
    box-shadow: none;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 500;
    color: #696c80;
  }
`;
